import React, { useEffect, useState } from 'react'
import Select from 'meinian-package/src/baseComponent/select'
import request from 'meinian-package/src/utils/request'

const convert = (result) => {
  return result.map(m => ({ label: m.nickName, value: m.userId }))
}
export default (props) => {
  const { inspirationId, placement, placeholder = '审核成员', ...otherProps } = props
  const [options, setOptions] = useState([])
  useEffect(() => {
    fetchUsers()
  }, [inspirationId])
  const fetchUsers = async () => {
    try {
      const res = await request.get('/zhikuan/ins/inspiration/auth/cooperation-user-list', { params: { inspirationId } })
      const _newData = res.filter(item => item.role === 1 || item.role === 2)
      setOptions(convert(_newData))
    } catch (err) {
      console.error(err)
    }
  }

  return <Select placement={placement} multi {...otherProps} data={options} placeholder={placeholder} />
}
